
  import { Component, Vue } from 'vue-property-decorator';

  @Component({
    components: {},
  })
  export default class Account extends Vue {
    formData: any = {
      loginName: '',
      password: ''
    }

    loading: any = false;

    async login() {
      // this.$router.push({
      //   name: "user"
      // });

      this.loading = true;
      (this.$refs.form as any).validate(async (valid: boolean) => {
        if (valid) {
          try {
            const res = await this.$store.dispatch({
              type: 'account/login',
              data: {
                password: this.formData.password,
                loginName: this.formData.loginName
              }
            });

            localStorage.setItem('Authorization', res.data.data.jwt);
            localStorage.setItem('loginName', res.data.data.loginName);
            localStorage.setItem('fullName', res.data.data.fullName);
            localStorage.setItem('roleTypeKeys', res.data.data.roleTypeKeys);
            localStorage.setItem('superAdmin', res.data.data.superAdmin);

            if (res.data.data.superAdmin) {
              this.$router.push({
                name: "user"
              });
            }
            else {
              this.$router.push({
                name: "resource"
              });
            }

            this.loading = false;
          }
          catch (e) {
            this.loading = false;
          }


        }
        else {
          this.loading = false;
        }
      });
    }


    ruleValidate = {
      loginName: [
        { required: true, message: '请输入用户名', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' }
      ]
    };
  }
